import {Component, Inject, Input} from '@angular/core';
import {OptionTypeUpper} from "../../models/option-type";
import {DialogService} from "../../services/dialog.service";
import {DataService} from "../../services/data.service";
import {DialogFormService} from "../../services/dialog-form.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ShareClientId} from "../../services/data/companies.service";
import {TranslateService} from "@ngx-translate/core";
import {FormControl, FormGroup} from "@angular/forms";
import { ResponseDto } from '../../models/dto/response';


@Component({
  selector: 'app-dialog-edit-option-description',
  templateUrl: './dialog-edit-option-description.component.html',
  styleUrl: './dialog-edit-option-description.component.scss'
})
export class DialogEditOptionDescriptionComponent {
  form: FormGroup
  optionType: OptionTypeUpper

  constructor(
    private dialogService: DialogService,
    private dataService: DataService,
    private dialogFormService: DialogFormService,
    private dialogRef: MatDialogRef<DialogEditOptionDescriptionComponent>,
    protected shareClientId: ShareClientId,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: OptionTypeUpper
  ) {
    this.optionType = data;
    this.form = new FormGroup({
      description: new FormControl(""),
      descriptionEn: new FormControl("")
    })

    if (data.Description != "" && data.Description != null) {
      this.form.get("description")?.setValue(data.Description)
    }
    if (data.DescriptionEn != "" && data.DescriptionEn != null) {
      this.form.get("descriptionEn")?.setValue(data.DescriptionEn)
    }
  }

  save() {
    this.dialogFormService.confirmChangeOptionDescription(
      this.optionType.ID,
      this.form.get("description")?.value,
      this.form.get("descriptionEn")?.value
    ).subscribe((response: ResponseDto) => {
      if (response.success) {
        this.dialogRef.close({success: true});
      }
    })
  }
}
